import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import {styled, Theme} from '@mui/material/styles';
import {
  Button,
  ButtonVariant,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';

const actionColor = '#0070C9';

const StyledButton = styled(Button)({
  color: actionColor,
  fontWeight: 600,
  '&:hover': {
    color: actionColor,
  },
  '&:focus': {
    color: actionColor,
  },
});

export const ActionButton = (props: React.ComponentProps<typeof Button>) => {
  const isMediumDown = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('lg'),
  );

  return (
    <StyledButton
      variant={ButtonVariant.text}
      size={isMediumDown ? 'medium' : 'large'}
      {...props}
    />
  );
};
